{{#each allInstanceVariablesWithFieldMacro}}
`{{ fieldMacroType }}({{ join fieldMacroArgs ", " }}, {{ join fieldMacroFlags " | " }})
{{/each}}
